import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalSection() {
  return <section className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-58">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-59"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl leading-relaxed font-light" data-id="element-61">
          <p className="font-serif text-3xl md:text-4xl font-bold text-terracotta mb-12" data-id="element-62">
            Son las 2:17 AM.
          </p>

          <p data-id="element-63">Tu hijo se despierta llorando.</p>

          <p data-id="element-64">y sientes que esta Ardiendo.</p>

          <p data-id="element-65">
            Y en ese segundo — ese segundo exacto — tu mente entra en un bucle.
          </p>

          <div className="pl-6 border-l-2 border-terracotta/50 italic text-cream/80 my-8" data-id="element-66">
            <p data-id="element-67">
              ¿Le doy algo ahora o espero? ¿Cuánta temperatura es peligrosa? ¿Y
              si es algo más que fiebre? ¿Llamo al médico a esta hora?
            </p>
          </div>

          <p data-id="element-68">Abres Google.</p>

          <p data-id="element-69">
            Y encuentras 47 respuestas distintas, 12 foros de opiniones
            contradictorias, y tres artículos que te dicen exactamente lo
            opuesto.
          </p>

          <p data-id="element-70">
            Veinte minutos después, sigues ahí. Agotada. Aterrorizada. Y sin
            haber hecho absolutamente nada.
          </p>

          <div className="pt-8 mt-12 border-t border-cream/10" data-id="element-71">
            <p className="text-2xl md:text-3xl font-serif font-medium text-center text-terracotta-light" data-id="element-72">
              Eso no es falta de amor. Eso es falta de un sistema.
              <br data-id="element-73" />
              <span className="text-white block mt-4 text-xl md:text-2xl" data-id="element-74">
                Y ninguna mamá debería enfrentar esa noche sin uno.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}